<template>
    <div ref="swiperWrapper" class="relative">
        <div ref="swiperEl" class="swiper">
            <div class="swiper-wrapper">
                <slot />
            </div>

            <div class="swiper-scrollbar" />
        </div>

        <slot name="navigation"/>
    </div>
</template>

<script setup>
    import Swiper from 'swiper'
    import { EffectFade, Autoplay, Navigation, Pagination, Grid, Thumbs } from 'swiper/modules'

    // import Swiper and modules styles
    import 'swiper/css'
    // import 'swiper/css/navigation'
    import 'swiper/css/effect-fade'
    import 'swiper/css/pagination'
    import 'swiper/css/grid'
    import 'swiper/css/thumbs'

    const emit = defineEmits(['init', 'autoplay-time-left', 'slide-change'])

    const props = defineProps({
        options: Object,
    })

    const swiper = ref(null)

    const swiperWrapper = ref(null)
    const swiperEl = ref(null)

    onMounted(() => {
        // grab swiper elements based on class
        const swiperPagination = swiperWrapper.value.querySelector('.swiper-pagination')
        const swiperButtonPrev = swiperWrapper.value.querySelector('.button-prev')
        const swiperButtonNext = swiperWrapper.value.querySelector('.button-next')

        // init Swiper:
        swiper.value = new Swiper(swiperEl.value, {
            modules: [Autoplay, EffectFade, Navigation, Pagination, Grid, Thumbs],
            slidesPerView: 1,
            loop: true,

            pagination: {
                el: swiperPagination,
            },

            navigation: {
                prevEl: swiperButtonPrev,
                nextEl: swiperButtonNext,
            },

            ...props.options,
        })

        swiper.value.on('slideChange', (event) => {
            emit('slide-change', event)
        })

        swiper.value.on('autoplayTimeLeft', (event) => {
            emit('autoplay-time-left', event)
        })

        emit('init', swiper.value)
    })

    onBeforeUnmount(() => {
        if (swiper.value) {
            swiper.value.destroy()
        }
    })

    defineExpose({
        swiper,
    })
</script>

<style lang="scss">
    .swiper-button-lock {
        @apply hidden;
    }

    .swiper-button-disabled {
        @apply opacity-50 pointer-events-none;
    }
</style>